export const commonMessages = {
  "common.navigation.nextBook": "Choose next book",
  "common.language": "Language",
  "common.locale.en": "English",
  "common.locale.es": "Spanish",
  "common.locale.de": "German",
  "common.locale.fr": "French",
  "common.save": "Save",
  "common.saved": "Language preference saved.",
  "common.saveError": "The language preference could not be saved.",
  "common.items": "{count, plural, =0 {No items} one {# item} other {# items}}",
  "common.books": "Books",
  "common.collections": "Collections",
  "common.pages": "Pages",
  "common.page": "page",
  "common.minutes": "Minutes",
  "common.readingDays": "Reading days",
  "common.completedBooks": "Completed books",
  "common.booksCount": "{count, plural, one {# book} other {# books}}",
  "common.sessionsCount": "{count, plural, one {# session} other {# sessions}}",
  "common.daysCount": "{count, plural, one {# day} other {# days}}",
  "common.cadence.weekly": "Weekly",
  "common.cadence.monthly": "Monthly",
  "common.goalStatus.empty": "Not started",
  "common.goalStatus.active": "Active",
  "common.goalStatus.completed": "Completed",
  "common.goalStatus.overdue": "Overdue",
  "common.goalLabel": "{cadence} goal",
  "common.goalProgress": "{label} goal: {percentage}% complete",
  "common.dashboard.dayStreak": "Day streak",
  "common.dashboard.minutesThisWeek": "Minutes this week",
  "common.dashboard.pagesThisWeek": "Pages this week",
  "common.dashboard.readingDaysValue": "{count} of 7",
  "common.stats.mostActiveDay":
    "Your most active day was {date}, with {duration} of reading.",
  "common.stats.moreReadingRhythm":
    "Your most active day will appear after you record more sessions.",
  "common.library.countWithFilters":
    "{count, plural, one {# book} other {# books}}{filtered, select, yes { matching your filters} other {}}",
  "common.library.addBook": "Add book",
  "common.library.addFirstBook": "Add your first book",
  "common.library.yourWishlist": "Your wishlist",
  "common.library.yourLibrary": "Your library",
  "common.library.wishlistEmpty": "Your wishlist is empty",
  "common.library.libraryEmpty": "Your library is empty",
  "common.library.addWishlistDescription":
    "Add a book you want to read and it will appear here.",
  "common.library.addLibraryDescription":
    "Add a book to start tracking your reading and progress.",
  "common.library.wantToReadDescription": "Books marked Want to read will appear here.",
  "common.library.tryAnotherFilter": "Try another search term or library section.",
  "common.library.noFilterMatches": "No books match these filters",
  "common.library.groupIntoShelves":
    "Group books into shelves that match how you read.",
  "common.actions.saving": "Saving…",
  "common.actions.saveChanges": "Save changes",
  "common.actions.addToLibrary": "Add to library",
  "common.actions.saveProgress": "Save progress",
  "common.actions.undo": "Undo",
  "common.journal.editEntry": "Edit journal entry",
  "common.journal.newEntry": "New journal entry",
  "common.journal.saveEntry": "Save entry",
  "common.journal.deleteConfirm": "Delete this private journal entry?",
  "common.journal.deleteTitle": "Delete this journal entry?",
  "common.library.deleteBookTitle": "Archive this book?",
  "common.library.deleteBookDescription":
    "“{title}” will move to archived books. Its reading history is preserved, and the action can be undone for 10 minutes.",
  "common.library.filters": "Filters",
  "common.settings.sections": "Settings sections",
  "common.theme.dark": "Dark mode",
  "common.theme.light": "Light mode",
  "common.theme.useDark": "Switch to dark mode",
  "common.theme.useLight": "Switch to light mode",
  "common.bookForm.editBook": "Edit book",
  "common.bookForm.addToLibrary": "Add to your library",
  "common.settings.unknownBrowser": "Unknown browser",
  "common.settings.thisDevice": "This device",
  "common.settings.unknownAddress": "Unknown address",
  "common.navigation.today": "Today",
  "common.navigation.library": "Library",
  "common.navigation.journal": "Journal",
  "common.navigation.insights": "Insights",
  "common.navigation.discover": "Discover",
  "common.navigation.community": "Community",
  "common.navigation.settings": "Settings",
  "common.navigation.help": "Help & docs",
  "common.navigation.more": "More",
  "common.routes.bookDetails": "Book details",
  "common.routes.login": "Login",
  "common.routes.createAccount": "Create account",
  "common.routes.home": "Home",
  "common.routes.notFound": "Page not found",
  "common.Layout.pageLoaded": "{route} page loaded",
  "common.Layout.closeNavigationMenu": "Close navigation menu",
  "common.Layout.mobileTabBar": "Primary mobile navigation",
  "common.Sidebar.reader": "Reader",
  "common.readingStatus.wishlist": "Wishlist",
  "common.readingStatus.all": "All books",
  "common.readingStatus.toRead": "To read",
  "common.readingStatus.reading": "Reading",
  "common.readingStatus.finished": "Completed",
  "common.readingStatus.didNotFinish": "Did not finish",
  "common.journalKind.note": "Note",
  "common.journalKind.quote": "Quote",
  "common.journalKind.highlight": "Highlight",
  "common.journalKind.reflection": "Reflection",
  "common.demo.eveningReading": "Evening reading",
  "common.forecast.eyebrow": "Reading pace",
  "common.forecast.title": "Finish-date estimate",
  "common.forecast.recentPace": "Recent calendar-day pace",
  "common.forecast.pagesPerDay": "{pace} pages per day",
  "common.forecast.estimatedFinish": "Estimated finish",
  "common.forecast.basis":
    "{confidence} confidence · {pages} validated pages on {activeDays} reading days across {observedDays} calendar days.",
  "common.forecast.disclaimer":
    "Estimate based on up to {lookback} recent calendar days, including days without reading. It is not a deadline.",
  "common.forecast.available": "A recent estimate is available.",
  "common.forecast.completed": "This book is complete—no estimate is needed.",
  "common.forecast.insufficient_data":
    "Read and log pages on at least two different days to see an estimate.",
  "common.forecast.missing_total":
    "Add a page total to estimate this book. Audiobook duration is not tracked yet.",
  "common.forecast.stalled":
    "There has been no recent page activity, so an older pace is not projected forward.",
  "common.forecast.confidence.low": "Low",
  "common.forecast.confidence.medium": "Medium",
  "common.forecast.confidence.high": "High",
  "common.forecast.loadError": "We couldn’t load the reading estimate",
} as const;
